import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Loader from '~/app/common/Loader';
import { route } from '~/app/helpers/route';
import { useStoreActions, useStoreState } from '~/store';
import { IssueOrServiceType } from '~/app/data/statuses/chat';
import ServiceChecklist from '~/services/Details/ServiceChecklist';
import { WORKORDER_ROUTES } from '~/workorder/Router';

export type TaskServiceCheckComponent = React.FC;

const TaskServiceCheck: TaskServiceCheckComponent = () => {
    const { id, type, taskId } = useParams<{ id: string; type: string; taskId: string }>();

    const history = useHistory();
    const [fetching, setFetching] = useState<boolean>(true);

    const taskData = useStoreState(state => state.workOrder.taskData);
    const getWorkOrderTaskDetail = useStoreActions(actions => actions.workOrder.getWorkOrderTaskDetail);

    const service = useStoreState(state => state.service.data);
    const fetchService = useStoreActions(actions => actions.service.fetchService);
    const machineId = useStoreState(state => state.service.data.machineId);
    const machine = useStoreState(state => state.machine.data);
    const fetchMachine = useStoreActions(actions => actions.machine.fetchMachine);

    const serviceId = taskData.id ?? 0;
    const taskLoaded = Number(taskData.id) === Number(taskId);

    useEffect(() => {
        if (!taskLoaded) {
            getWorkOrderTaskDetail({
                id: Number(id),
                taskId: Number(taskId),
                type: type === 'issue' ? IssueOrServiceType.ISSUE : IssueOrServiceType.SERVICE,
            });
        }
    }, [taskLoaded, getWorkOrderTaskDetail, id, taskId, type]);

    useEffect(() => {
        if (!taskLoaded) {
            return;
        }
        if (!serviceId) {
            setFetching(false);
            return;
        }

        const loadServiceAndMachine = async () => {
            setFetching(true);
            if (machineId && Number(machine?.id) !== Number(machineId)) {
                await fetchMachine(machineId);
            }
            if (Number(service.id) !== Number(serviceId)) {
                await fetchService(serviceId.toString());
            }
            setFetching(false);
        };

        loadServiceAndMachine();
    }, [taskLoaded, serviceId, service.id, fetchService, fetchMachine, machineId, machine]);

    if (fetching) {
        return <Loader size="32" />;
    }

    return (
        <ServiceChecklist
            serviceId={serviceId.toString()}
            subTitle={(service.machineIntern + ' - ' + service.machineName).toUpperCase()}
            backLink={history.length > 1 ? history.goBack : route(WORKORDER_ROUTES.taskDetail, { id, type, taskId })}
            isWorkOrderChecklist
        />
    );
};

export default TaskServiceCheck;
